if (!customElements.get('sesseq-shop-look')) {
  customElements.define('sesseq-shop-look', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      const opener = this.querySelector('[data-look-open]');
      const dialog = this.querySelector('dialog');
      if (!opener || !dialog) return;
      opener.addEventListener('click', () => {
        dialog.showModal();
        dialog.scrollTop = 0;
        dialog.querySelector('.sesseq-look__panel').scrollTop = 0;
      });
      this.querySelector('[data-look-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => opener.focus({preventScroll:true}));
    }
  });
}

